<!--
props
/* 各パラメータの説明 */
* areas: [id: Int, name: Str, prefectures: [id: Int, name: Str]] 地域の連想配列
* checkedIds: [Int] 選択された都道府県のId

emit
/* イベントの説明 */
* close() : 閉じるボタンが押された時に、発火する
* submitData(prefectureIds: [Int:[Int]]) : 決定するボタンが押された時に発火する。
  * prefectureIds:
    * key: 都道府県が属するエリアのid
    * value: 選択された都道府県のId
-->

<template>
  <!-- sub area -->
  <div class="sub_search_wrap-contents_area">
    <div class="sub_search-contents_titwrap">
      <div class="sub_contents-tit">
        <span class="sub_contents_close" v-on:click="close()">×</span>
        <span class="sub_contents_tit_txt">エリア</span>
        <span class="sub_contents_tit_clear"><a v-on:click="areasStore.clear()">すべてクリア</a></span>
      </div>
    </div>

    <div class="sub_search-contents_area">
      <div class="sub_search-contents_table">
        <table class="m3-table m3-table-search-toggle">
          <tbody>
            <!-- // エリアで繰り返す -->
            <PrefectureComponent
              v-for="area in areasStore.master"
              :areaId="area.id"
              :areaName="area.name"
              :prefectures="area.prefectures"
              :checkedIds="areasStore.get(area.id)"
              :ref="`prefectures${area.id}`"
              :key="area.id"
              @updateValue="updateValues"
            />
          </tbody>
        </table>
      </div>
    </div>

    <div class="sub_search-fixbtnbox">
      <ul class="sub_search-btn">
        <li><button type="submit" class="link_btn_green">検索する</button></li>
      </ul>
    </div>
  </div>
</template>


<script setup>
import { inject } from 'vue'
import PrefectureComponent from '@component_path/search-contents/components/prefecture'
import { setupModal } from '@component_path/lib/modal.js'
setupModal('.sub_search-contents_area')
const emit = defineEmits(['close'])
const areasStore = inject('areasStore')

/* methods */
const updateValues = (areaId, value) => { areasStore.set(areaId, value) }
const close = () => {
  areasStore.reset()
  emit('close')
}
</script>
